import { FORM_SLOT_DESIGN_FIELDS } from './design-fields';
/**
 * Inline style that carries a slot node's design to the `--wst-*` tokens Wix Forms' React-Aria skin
 * reads.
 *
 * Ricos resolves every colour before the block sees it: a colour the writer left alone arrives as
 * `var(--ricos-theme-color-N, #default)`, a reference to the surrounding surface with ricos' theme
 * default as the CSS fallback; an opaque theme pick as the bare `var(--ricos-theme-color-N)`; a
 * translucent one as `rgba(var(--ricos-theme-color-N-tuple), a)`; a custom colour as its hex. All
 * four are paintable CSS, so every colour is forwarded as-is and ricos stays the single statement of
 * the unset case — nothing here guesses set-vs-unset from the string, and the design panel's "follow
 * theme" swatch and the rendered form read the same value.
 *
 * The tokens Forms reads that ricos has no field for (muted ink, disabled colour, input background)
 * are derived from these in `forms-slot-theme-bridge.scss`, which lands on the same element. Which
 * tokens each field drives lives in `design-fields.ts`.
 */
export const getFormSlotDesignStyle = (design) => {
    const style = {};
    const writeVars = (key, value) => {
        FORM_SLOT_DESIGN_FIELDS[key].vars.forEach((cssVar) => {
            style[cssVar] = value;
        });
    };
    [
        'textColor',
        'accentColor',
        'backgroundColor',
        'buttonColor',
        'buttonTextColor',
        'borderColor',
    ].forEach((key) => {
        writeVars(key, design[key]);
    });
    // Ricos defaults every numeric field to 0, so a length the writer left alone falls through to
    // Forms' own default (1px stroke, square corners, its grid gaps). An explicit 0 is
    // indistinguishable from unset here, and reads as unset — which for stroke and radius is also what
    // the skin's fallback gives, so nothing is lost.
    ['rowGap', 'columnGap', 'borderWidth', 'borderRadius'].forEach((key) => {
        if (design[key] > 0) {
            writeVars(key, `${design[key]}px`);
        }
    });
    if (design.paddingVertical > 0 || design.paddingHorizontal > 0) {
        style.padding = `${design.paddingVertical}px ${design.paddingHorizontal}px`;
    }
    return style;
};
//# sourceMappingURL=form-slot-design-style.js.map